import { ref, watch } from 'vue';

export default ({ data, searchParams, addSearchParam }) => {
  const sortOptions = {
    'Featured': 'manual',
    'Best Sellers': 'best-selling',
    "New Arrivals": 'created-ascending',
    'Price: High to Low': 'price-descending',
    'Price: Low to High': 'price-ascending',
  }

  const sortOrderDisplayNames = {
    'manual': 'Featured',
    'best-selling': 'Best Sellers',
    'created-ascending': 'New Arrivals',
    'price-descending': 'Price: High to Low',
    'price-ascending': 'Price: Low to High',
  }

  const sortOrder = ref(sortOrderDisplayNames[data.value.default_sort_by] ? sortOrderDisplayNames[data.value.default_sort_by] : 'Best Sellers')
  const { 'sort-order': sortOrderArg } = searchParams.value

  if (Object.values(sortOptions).includes(sortOrderArg)) {
    sortOrder.value = Object.fromEntries(
      Object.entries(sortOptions).map(([key, val]) => [val, key])
    )[sortOrderArg]
  }

  watch(sortOrder, () =>
    addSearchParam('sort-order', sortOptions[sortOrder.value])
  )

  return {
    sortOptions,
    sortOrder,
    sortOrderDisplayNames
  }
}